<span [ngClass]="{ 'nav-fixed': !static }">
    <sb-top-nav></sb-top-nav>
    <div id="layoutSidenav">
        <div id="layoutSidenav_nav">
            <sb-side-nav [sidenavStyle]="sidenavStyle" [sideNavItems]="sideNavItems$ | async" [sideNavSections]="sideNavSections$ | async"></sb-side-nav>
        </div>
        <div id="layoutSidenav_content" [ngClass]="{ scrollable: !static }" (click)="closeSideNavIfOpen()">
            <main>
                <ng-container *ngTemplateOutlet="defaultContent"></ng-container>
            </main>
            <sb-footer></sb-footer>
        </div>
    </div>
</span>
<fina-payment-renewal-banner></fina-payment-renewal-banner>
<fina-support-session-banner></fina-support-session-banner>
<ng-template #defaultContent>
    <ng-content></ng-content>
</ng-template>
<ng-template let-modal #modalInactive>
    <div class="modal-body px-5">
        <h1 class="text-center text-purple mb-5 pt-5"><strong>Tu cuenta ha sido desactivada</strong></h1>
        <h3 class="text-center mb-5">
            Tu cuenta se encuentra inactiva por falta de pago o un error en el mismo. Para reactivar tu comercio, registra el pago de tu mensualidad y nuestro equipo lo validará a la brevedad.
        </h3>
        <h5 class="text-center px-5 mb-4">Una vez validado el pago, recuperarás el acceso completo a tu comercio.</h5>
    </div>
    <div class="modal-footer2 border-top-0 pb-5 justify-content-center">
        <fina-form-pay-plan title="Quiero reactivar mi cuenta"></fina-form-pay-plan>
    </div>
    <div class="modal-footer border-top-0 pb-5 justify-content-center">
        <a class="" href="https://wa.me/584123502334?text=Hola%2C%20mi%20cuenta%20est%C3%A1%20inactiva%20y%20necesito%20ayuda%20para%20reactivarla." target="_blank">
            Contactar soporte por WhatsApp
        </a>
    </div>
</ng-template>
<ng-template let-modal #modalInitial>
    <div class="modal-body px-5">
        <h1 class="text-center text-purple mb-5 pt-5"><strong>Bienvenido a tu comercio Fina</strong></h1>
        <h3 class="text-center mb-5">Tu cuenta esta vencida. Para poder continuar con tu comercio debes registrar tu pago.</h3>
        <h5 class="text-center mb-5" *ngIf="planRejected">Tienes un pago rechazado. Para ver los detalles, haz click en el botón "Ver pago rechazado".</h5>
        <h5 class="text-center px-5">Si ya realizaste el pago o estás por realizarlo, puedes registrarlo haciendo click en el boton "Registrar pago".</h5>
    </div>
    <div class="modal-footer border-top-0 pb-5">
        <div class="box-btn-cancel">
            <fina-form-pay-plan></fina-form-pay-plan>
        </div>
        <div class="box-btn-cancel" *ngIf="planRejected">
            <button class="btn btn-outline-danger" type="button" (click)="open(modalLastPayments, { size: 'md', centered: true })">Ver pago rechazado</button>
        </div>
    </div>
</ng-template>

<ng-template #modalLastPayments let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Datos de pago</h5>
    </div>
    <div class="m-4">
        <div class="d-flex justify-content-between">
            <label class="small mb-1" for="paymentMethod"><b>Fecha de cobro</b></label>
            <label class="small mb-1 ms-4">{{ (plansService.plansBundle$ | async).rejectedCurrentBill?.paymentDatePlan | date : 'MMM d, y' : 'UTC' | titlecase }}</label>
        </div>
        <div class="d-flex justify-content-between">
            <label class="small mb-1" for="paymentMethod"><b>Fecha de factura generada</b></label>
            <label class="small mb-1" for="paymentMethod">{{ (plansService.plansBundle$ | async).rejectedCurrentBill?.createdAt | date : 'MMM d, y' | titlecase }}</label>
        </div>
        <div class="d-flex justify-content-between">
            <label class="small mb-1" for="paymentMethod"><b>Fecha de pago realizado</b></label>
            <label class="small mb-1" for="paymentMethod">{{ (plansService.plansBundle$ | async).rejectedCurrentBill?.paidDate | date : 'MMM d, y - HH:mm aa' | titlecase }}</label>
        </div>

        <hr class="px-2" />
        <div class="d-flex justify-content-between">
            <label class="small mb-1" for="paymentMethod"><b>Metodo de pago</b></label>
            <label class="small mb-1" for="paymentMethod">{{ (plansService.plansBundle$ | async).rejectedCurrentBill?.paymentMethod?.name || '--' }}</label>
        </div>
        <div class="d-flex justify-content-between">
            <label class="small mb-1" for="paymentMethod"><b>N° Referencia</b></label>
            <label class="small mb-1" for="paymentMethod">{{ (plansService.plansBundle$ | async).rejectedCurrentBill?.ref || '--' }}</label>
        </div>
        <div class="d-flex justify-content-between">
            <label class="small mb-1" for="paymentMethod"><b>Nombre del emisor</b></label>
            <label class="small mb-1 w-75 text-end" for="paymentMethod">{{ (plansService.plansBundle$ | async).rejectedCurrentBill?.issuing || '--' }}</label>
        </div>
        <div class="d-flex justify-content-between">
            <label class="small mb-1" for="paymentMethod"><b>Comentarios</b></label>
            <label class="small mb-1 w-75 text-end" for="paymentMethod">{{ (plansService.plansBundle$ | async).rejectedCurrentBill?.comments || '--' }}</label>
        </div>

        <hr class="px-2" />
        <div class="d-flex justify-content-between">
            <label class="small mb-1" for="paymentMethod"><b>Total</b></label>
            <label class="small mb-1" for="paymentMethod">{{ (plansService.plansBundle$ | async).rejectedCurrentBill?.amount | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</label>
        </div>
        <div class="d-flex justify-content-between" *ngIf="(plansService.plansBundle$ | async).rejectedCurrentBill?.amountVES">
            <label class="small mb-1" for="paymentMethod"><b>Total Bs</b></label>
            <label class="small mb-1" for="paymentMethod">{{ ((plansService.plansBundle$ | async).rejectedCurrentBill?.amountVES | currency : 'BS') || '--' }}</label>
        </div>
        <div class="d-flex justify-content-between" *ngIf="(plansService.plansBundle$ | async).rejectedCurrentBill?.amountVES">
            <label class="small mb-1" for="paymentMethod"><b>Tasa de cambio</b></label>
            <label class="small mb-1" for="paymentMethod">{{ ((plansService.plansBundle$ | async).rejectedCurrentBill?.exchangeRateBCV | currency : 'BS') || '--' }}</label>
        </div>

        <hr class="px-2" />
        <div class="d-flex justify-content-between">
            <label class="small mb-1 text-danger" for="paymentMethod"><b>Motivo del rechazo</b></label>
            <label class="small mb-1 text-danger" for="paymentMethod">{{ (plansService.plansBundle$ | async).rejectedCurrentBill?.reasonRejected | titlecase }}</label>
        </div>
    </div>
</ng-template>
